import { CuratedMediaList, Media, ProcessedMedia } from 'models';
import React, { useEffect, useState } from 'react';
import RedQuickOrderedList from './RedQuickOrderedList';
import { Badge, Button, Grid, Typography } from '@mui/material';
import TitleService from 'title-service';
import AnimateButton from 'ui-component/extended/AnimateButton';
import RedQuickTextField from './RedQuickTextField';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { Avatar, Box } from '@mui/material';
import { get_all_media } from 'features/media/media-slice';
import { useSelector } from 'react-redux';

interface CuratedMediaListEditorProps {
    list: CuratedMediaList;
    contextId: string;
    onChange: (list: CuratedMediaList) => void;
    onAddMedia: (list: CuratedMediaList) => void;
}

export const CuratedMediaListEditor: React.FC<CuratedMediaListEditorProps> = ({
    contextId,
    list,
    onChange,
    onAddMedia
}) => {
    const data = list;
    const all_media = useSelector(get_all_media);
    const [data_list, setDataList] = useState<{ i: any, data: Media }[]>(null);
    useEffect(() => {
        if (data?.media) {
            setDataList(data.media.filter(x => all_media.find(v => v.id === x.id)).map((item) => {
                return ({
                    i: item.id,
                    id: item.id,
                    data: item
                })
            }))
        }
    }, [JSON.stringify(data)]);

    return (
        <div>
            <Grid container spacing={2} >
                <Grid item>
                    <RedQuickTextField
                        value={data.name}
                        onChange={(value) => onChange({ ...data, name: value })}
                    />
                </Grid>
                <Grid item>
                    <AnimateButton>
                        <Button variant="contained" onClick={async () => {
                            onAddMedia(list)
                        }}>
                            {TitleService('Add')}
                        </Button>
                    </AnimateButton>
                </Grid>
            </Grid>
            {data_list ? <RedQuickOrderedList
                value={data_list}
                horizontal
                rowHeight={175}
                contextId={contextId}
                itemProperties={{
                    minH: 1,
                    minW: 1,
                    maxH: 1,
                    maxW: 1
                }}
                onChange={(media) => {
                    if (onChange) {
                        onChange({
                            ...data, media: media.map(t => {
                                const data = all_media.find(d => d.id === t.i)
                                return data;
                            })
                        });
                    }
                }}
                createElement={(item: { i: any }) => {
                    const data = all_media.find(d => d.id === item.i)
                    let imageUrl = data?.thumbnailDefaultUrl || data?.thumbnail;
                    return imageUrl ? <Box sx={{ position: 'relative' }}>
                        <Badge
                            overlap="circular"
                            badgeContent={
                                <FiberManualRecordIcon sx={{
                                    fontSize: '1.875rem'
                                }} />
                            }
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'right'
                            }}
                        >
                            <Avatar sx={({ height: '100%', aspectRatio: `1`, width: '100%' })} alt={data?.name} title={data?.name} src={imageUrl} />
                        </Badge>
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <span>{data?.name}</span>
                        </div>
                    </Box> : (
                        <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-list-details"
                            width="20" height="20" viewBox="0 0 24 24"
                            strokeWidth="1.5" stroke="#597e8d" fill="none"
                            strokeLinecap="round" strokeLinejoin="round">
                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                            <path d="M13 5h8" />
                            <path d="M13 9h5" />
                            <path d="M13 15h8" />
                            <path d="M13 19h5" />
                            <rect x="3" y="4" width="6" height="6" rx="1" />
                            <rect x="3" y="14" width="6" height="6" rx="1" />
                        </svg>
                    )
                }} // Replace with appropriate rendering logic
            /> : null}
        </div>
    );
};
